import React from 'react'

import { Container } from './styles'

interface PaginationItemProps {
    number: number
    isCurrent?: boolean
    onPageChange: (page: number) => void
}

export const PaginationItem: React.FC<PaginationItemProps> = ({
    number,
    isCurrent,
    onPageChange
}) => {
    if (isCurrent) {
        return (
            <Container className="pagination-item">
                <button type="button" disabled>
                    {number}
                </button>
            </Container>
        )
    }

    return (
        <Container className="pagination-item">
            <button
                type="button"
                onClick={() => {
                    onPageChange(number)
                }}
            >
                {number}
            </button>
        </Container>
    )
}
